import { z } from 'zod';
import type { AST } from '@cotera/era';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';
import { artifactsCreateResponseSchema } from './common-responses';

export const artifactsCreateBodyV20260601Schema = z.object({
  ast: z.custom<AST.RelFR>(),
  acceptStaleWithinSeconds: z.number().optional(),
});

export type ArtifactsCreateBody = z.infer<
  typeof artifactsCreateBodyV20260601Schema
>;

export class ArtifactsCreateV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'artifacts-create-2026-06-01' as const;

  readonly name = ArtifactsCreateV20260601Schema.version;
  readonly schema = artifactsCreateBodyV20260601Schema;
  readonly response = artifactsCreateResponseSchema;
  readonly scopes = ['write', 'warehouse'] as const;
}

export const ARTIFACTS_API_SCHEMAS = [
  ArtifactsCreateV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
